module.exports = __webpack_public_path__ + "static/media/solidaria.278ec2a6.png";